import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFocusSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"focus-square"} maskId="square-filled-radius-0-stroke-1-IconFocusSquare"><path d="M3 3H8.5V4H4V8.5H3V3Z" fill="currentColor"/><path d="M15.5 3H21V8.5H20V4H15.5V3Z" fill="currentColor"/><path d="M4 15.5V20H8.5V21H3V15.5H4Z" fill="currentColor"/><path d="M21 15.5V21H15.5V20H20V15.5H21Z" fill="currentColor"/><path d="M16 8H8V16H16V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFocusSquare;
